module.exports = __webpack_public_path__ + "static/media/Pharaoh.cdd11e2f.jpg";